<template>
  <div>
    <table class="table table-striped table-bordered" v-bind:key="mortgageTableKey">
      <thead>
      <tr>
        <th class="compact">
          Hypotheeknummer
        </th>
        <th class="compact">Reden</th>
        <th class="compact">Passeerdatum</th>
        <th class="compact">Geldverstrekker</th>
        <th class="compact">Onderpanden</th>
        <th class="compact">Hoofdsom en Restant</th>
        <th class="compact">Labels</th>
        <th class="compact"></th>
      </tr>
      </thead>
      <tbody>
      <mortgage-row-component
          v-for="mortgage in mortgages"
          v-bind:key="mortgage.id"
          v-bind:mortgage-id="mortgage.id"
          v-bind:property-attachable="isAttachable(mortgage)"
          v-bind:property-id="propertyId"
          v-on:collateral-unmatch="unmatchMortgageProperty"
          v-on:collateral-match="matchMortgageProperty"
      />
      </tbody>
    </table>

    <div v-for="mortgageProperty in mortgageProperties"
         v-bind:key="mortgageProperty.id"
         style="margin: 1.5rem 0">
      <edit-mortgage-property-component
          v-bind:display-mortgage-information="true"
          v-bind:mortgage-property-object="mortgageProperty"
          v-bind:show-mortgage-information="true"
          v-bind:show-property="false"
          v-on:new-change="loadMortgageProperties"
          v-bind:property="property"
          v-on:property-updated="onMortgagePropertyUpdated"
      :customer-id="customerId"/>
    </div>
  </div>
</template>

<script>
import mortgageRowComponent from "~/modules/mortgage/components/RowComponent"
import editMortgagePropertyComponent from "~/modules/mortgage_property/components/EditComponent"
import mortgagePropertyApi from "~/api/mortgage_property"

export default {
  name: "MortgagePropertyEditComponent",
  components: {
    mortgageRowComponent,
    editMortgagePropertyComponent
  },
  props: {
    mortgages: {
      type: Array,
      required: true
    },
    propertyId: {
      type: Number,
      required: true
    },
    customerId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data() {
    return {
      mortgageProperties: [],
      property: null,
      mortgageTableKey: 1
    };
  },
  mounted() {
    this.loadMortgageProperties()
  },
  computed: {},
  methods: {
    isAttachable(mortgage) {
      return !this.mortgageProperties.find(mortgageProperty => mortgageProperty.mortgage_id === mortgage.id);
    },
    onMortgagePropertyUpdated(property) {
      this.property = property
    },
    loadMortgageProperties() {
      if (this.customerId) {
        mortgagePropertyApi.findByPropertyForCustomer(this.propertyId, this.customerId, ['property', 'mortgage']).then(response => {
          this.mortgageProperties = response.data;
        })
      } else {
        mortgagePropertyApi.findByProperty(this.propertyId, ['property', 'mortgage']).then(response => {
          this.mortgageProperties = response.data;
        })
      }

    },
    unmatchMortgageProperty(mortgagePropertyId) {
      this.mortgageProperties = this.mortgageProperties.filter(mortgageProperty => {
        return mortgageProperty.id !== mortgagePropertyId;
      });

      this.mortgageTableKey++;
    },
    matchMortgageProperty(mortgagePropertyId) {
      mortgagePropertyApi.findById(mortgagePropertyId, ['property', 'mortgage']).then((response) => {
        this.mortgageProperties.push(response.data);
        this.mortgageTableKey++;
      })
    }
  }
}
</script>
<style scoped>
.search-component {
  position: relative;
}

.search-component .results {
  position: absolute;
  width: calc(100% - 10px);
  background: rgba(255, 255, 255, 0.91);
  margin: 5px;
  max-height: 300px;
  overflow: auto;
}
</style>
